// src/components/agora/AgoraWrapper.tsx
import { ReactNode, useEffect, useState, createContext, useContext } from "react";
import { AgoraRTCProvider, useRTCClient } from "agora-rtc-react";
import AgoraRTC from "agora-rtc-react";

export const AgoraRoleReadyContext = createContext(false);

export default function AgoraWrapper({
  mode = "live",
  role = "audience",
  codec = "vp8",
  children,
}: {
  mode?: "live" | "rtc";
  role?: "host" | "audience";
  codec?: "vp8" | "h264";
  children: ReactNode;
}) {
  AgoraRTC.enableLogUpload();
  AgoraRTC.setLogLevel(0);

  const [roleReady, setRoleReady] = useState(mode !== "live");

  const client = useRTCClient(
    AgoraRTC.createClient({
      mode,
      codec,
    }),
  );

  useEffect(() => {
    if (mode === "live") {
      client
        .setClientRole(role)
        .then(() => setRoleReady(true))
        .catch((err) => {
          console.error("Failed to set Agora client role:", err);
          setRoleReady(true); // Allow join anyway to avoid permanent block
        });
    } else {
      setRoleReady(true);
    }
  }, [client, mode, role]);

  // In live mode, do not mount children until client role is set.
  // This ensures the host joins as "host" (broadcaster) so the audience can see them.
  const shouldRenderChildren = mode !== "live" || roleReady;

  return (
    <AgoraRoleReadyContext.Provider value={roleReady}>
      <AgoraRTCProvider client={client}>
        {shouldRenderChildren ? children : null}
      </AgoraRTCProvider>
    </AgoraRoleReadyContext.Provider>
  );
}
